import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface TimelineNodeProps {
  year: number | string;
  title: string;
  description: string;
  icon: LucideIcon;
  isBreakthrough?: boolean;
  index: number;
}

const TimelineNode: React.FC<TimelineNodeProps> = ({
  year,
  title,
  description,
  icon: Icon,
  isBreakthrough,
  index
}) => {
  const isLeft = index % 2 === 0;

  return (
    <div className="relative flex items-center py-4">
      {/* Center Line */}
      <div className="absolute left-1/2 top-0 bottom-0 w-1">
        <div className="h-full w-full bg-brand/20 rounded-full shadow-[0_0_20px_rgba(62,207,142,0.3)]" />
      </div>

      {/* Content Container */}
      <div className={`flex items-center w-full ${isLeft ? 'flex-row' : 'flex-row-reverse'}`}>
        {/* Year */}
        <div className={`w-48 ${isLeft ? 'text-right pr-8' : 'text-left pl-8'}`}>
          <span className="text-4xl font-bold text-brand">{year}</span>
        </div>

        {/* Node */}
        <div className="relative z-10">
          <motion.div
            whileHover={{ scale: 1.1 }}
            className={`
              w-16 h-16 rounded-full flex items-center justify-center
              ${isBreakthrough ? 'bg-brand' : 'bg-brand/20'}
              shadow-[0_0_30px_rgba(62,207,142,0.4)]
              transition-all duration-300
            `}
          >
            <Icon className="w-8 h-8 text-white" />
          </motion.div>
        </div>

        {/* Content */}
        <div className={`flex-1 ${isLeft ? 'pl-8' : 'pr-8'}`}>
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="card p-4 bg-background-secondary/90 backdrop-blur-sm border border-gray-800/50 hover:border-brand/30 transition-all duration-300"
          >
            <h3 className="text-xl font-bold text-content-primary mb-2">{title}</h3>
            <p className="text-base text-content-secondary leading-relaxed">{description}</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default TimelineNode;